import { Component, OnInit, Input, ElementRef, AfterViewInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import videojs from 'video.js';  // Import Video.js

@Component({
  selector: 'app-kiron-player',
  templateUrl: './kiron-player.component.html',
  styleUrls: ['./kiron-player.component.scss'],
})
export class KironPlayerComponent implements OnInit, AfterViewInit {
  @Input() KironDGVideoUrl: any;
  @Input() KironHRVideoUrl: any;

  selected_video: any;
  urlSwitchOption: boolean;
  player: any;

  constructor(public modalController: ModalController, private elRef: ElementRef) { }

  ngOnInit() {
    // Default selected video URL
    this.urlSwitchOption = false;
    this.selected_video = this.KironHRVideoUrl;
  }

  ngAfterViewInit() {
    // Initialize Video.js after view is rendered
    this.initializePlayer();
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  toggle_switch(e) {
    // Change the video URL based on toggle
    if (e.detail.checked) {
      this.selected_video = this.KironDGVideoUrl;
    } else {
      this.selected_video = this.KironHRVideoUrl;
    }

    // Reload the video when URL is switched
    const player = this.elRef.nativeElement.querySelector('video');
    this.player.src({ type: this.getVideoType(this.selected_video), src: this.selected_video });
    this.player.load();
  }

  initializePlayer() {
    const videoElement = this.elRef.nativeElement.querySelector('#video-player');
    this.player = videojs(videoElement);
  }

  getVideoType(url: string) {
    if (url.includes('.m3u8')) {
      return 'application/x-mpegURL';
    } else if (url.includes('.mp4')) {
      return 'video/mp4';
    } else {
      return 'video/mp4';
    }
  }
}
